import { useEffect, useState, useContext } from "react";
import { useStore } from "../../state/state.ts";
import './input-plz.css'
import TextInput from "./input-text.tsx";
import { ConfigContext } from "../../config_context.ts";
import { SkipLinkFocus } from "../skip-link-focus.tsx";

export default function PlzInput (props: {
  label?: string,
  value: string,
  placeholder?:number,
  disabled?: boolean,
  onChange: (value: string) => void,
  onBlur?: () => void,
}){
  const plz_validation = useContext(ConfigContext).plz_validation;
  const plz_default = useContext(ConfigContext).plz_default;

  const country = useContext(ConfigContext).country;
  const [valid, setValid] = useState(false);
  const api_check_zip = useStore((state)=>state.api_check_zip);
  const region_name = useStore((state)=>state.region_name);

  useEffect(()=>{
      if (region_name && plz_validation(props.value)){
        setValid(true);
      }
    },[region_name]
  );

  const validate = async (v:string)=>{
    if (!v) {return false;}
    return  plz_validation(v) && v.match(/^\d*$/g);
  };
 
  //console.log("plz", region_name);

  return <div style={{position: "relative", width: "100%"}}>
        <TextInput 
        type="text" 
        hint={"Bitte eine gültige Postleitzahl z.B. "+plz_default+" eingeben."} 
        postfix={valid ? region_name : ""} 
        label={props.label} 
        value={props.value ? props.value.toString() : ""}
        placeholder={props.placeholder ? props.placeholder.toString() : ""}
        disabled={props.disabled}
        onBlur={props.onBlur}
        onChange={(v) => {
          return props.onChange(v?.replace(/\D/g, ''));
        }} 
        validate={validate}
        onValidate={setValid}
      />
      {valid && <SkipLinkFocus label="zum Weiter-Button springen" target="next-button"></SkipLinkFocus>}
    </div>
}